import { Component, inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AlertConfig } from '../user.service';
import {
  createAlertConfigFormGroup,
  patchAlertConfigForm,
  setAlertConfigRetryScheduleActive,
} from '../../configuration/alert-config-form.builder';
import { AlertConfigFormFieldsComponent } from '../../configuration/alert-config-form-fields/alert-config-form-fields.component';
import { MaterialModule } from '../../shared/material/material.module';
import {
  CAMPAIGN_CYCLE_UI_SLOTS,
  cycleSlotsForCampaignUi,
} from '../../notification/model/alert-cycle.util';

export type CampaignAlertConfigDialogData = {
  title: string;
  description?: string;
  locationLabel?: string;
  alertConfig: AlertConfig;
  campaignStartMs: number;
};

@Component({
  selector: 'app-campaign-alert-config-dialog',
  standalone: true,
  imports: [MatDialogModule, ReactiveFormsModule, MaterialModule, AlertConfigFormFieldsComponent],
  templateUrl: './campaign-alert-config-dialog.component.html',
  styleUrl: './campaign-alert-config-dialog.component.scss',
})
export class CampaignAlertConfigDialogComponent implements OnInit {
  #dialogRef = inject(MatDialogRef<CampaignAlertConfigDialogComponent>);
  readonly data: CampaignAlertConfigDialogData = inject(MAT_DIALOG_DATA);

  readonly alertConfigForm = createAlertConfigFormGroup();
  readonly customScheduleEnabled = new FormControl(false, { nonNullable: true });
  readonly cycleSlots = new FormArray<
    FormGroup<{
      date: FormControl<string>;
      time: FormControl<string>;
    }>
  >([]);

  ngOnInit(): void {
    patchAlertConfigForm(this.alertConfigForm, this.data.alertConfig);
    setAlertConfigRetryScheduleActive(this.alertConfigForm, true);

    while (this.cycleSlots.length < CAMPAIGN_CYCLE_UI_SLOTS) {
      this.cycleSlots.push(
        new FormGroup({
          date: new FormControl('', { nonNullable: true }),
          time: new FormControl('', { nonNullable: true }),
        }),
      );
    }

    const rows = cycleSlotsForCampaignUi(this.data.alertConfig, this.data.campaignStartMs);
    rows.forEach((row, index) => {
      this.cycleSlots.at(index).patchValue(row, { emitEvent: false });
    });

    this.alertConfigForm.disable({ emitEvent: false });
    this.customScheduleEnabled.disable({ emitEvent: false });
    this.cycleSlots.disable({ emitEvent: false });
  }

  onClose(): void {
    this.#dialogRef.close();
  }
}
